const YMX = {
  AmazonRenewed: 'Amazon Renewed',
  CD: 'CD',
  ClimatePledgeFriendly: 'Climate Pledge Friendly',
  Kindle: 'Kindle商店',
  musicalInstrument: 'musicalInstrument',
  AmazonDevicesAndHardware: 'AmazonDevices and Hardware',
  SportsCollectibles: 'Sports collectibles',
  HomeFurnishings: 'Health and Home Furnishings',
  officeSupplies: 'office supplies ',
  KitchenRestaurant: 'Kitchen and Restaurant',
  CollectibleCoins: 'Collectible coins',
  VariousDelicacies: 'Various delicacies',
  books: 'books',
  Subtotal: '大家电',
  Subtotal: '娱乐收藏品',
  Subtotal: '婴儿用品',
  Subtotal: '宠物用品',
  Subtotal: '家居、厨具、家装',
  Subtotal: '家居装修',
  Subtotal: '工业与科研用品',
  Subtotal: '应用和游戏',
  Subtotal: '庭院、草坪和园艺',
  Subtotal: '手工制品',
  Subtotal: '手机和配件',
  Subtotal: '摄影摄像器材',
  Subtotal: '数字教育材料',
  Subtotal: '数字音乐',
  Subtotal: '有声读物和原创作品',
  Subtotal: '服装、鞋靴和珠宝饰品',
  Subtotal: '汽车用品',
  Subtotal: '独特发现',
  Subtotal: '玩具和游戏',
  Subtotal: '电子',
  Subtotal: '电影和电视',
  Subtotal: '视频游戏',
  Subtotal: '美容和个人护理',
  Subtotal: '艺术、工艺与缝纫用品',
  Subtotal: '计算机及配件',
  Subtotal: '软件',
  Subtotal: '运动户外休闲',
};

module.exports = YMX
